// src/services/profiles/memberProfileApi.ts

import baseApi from "../../lib/baseApi";
import { UpdateMemberProfileResponse } from "../../types/profiles/updateMemberProfileResponse";

// Member Profile APIs ---------------------------------------------------------------
export const fetchMemberProfileApi = async () => {
  const response = await baseApi.get("/profiles/members/my-profile/");
  return response.data;
};

export const updateMemberProfileApi = async (
  updatedData: any
): Promise<UpdateMemberProfileResponse> => {
  const response = await baseApi.post(
    "/profiles/members/update-profile/",
    updatedData
  );

  return {
    message: response.data.message,
    member: response.data.member,
    user: response.data.user,
  };
};

export const updateMemberProfileImageApi = async (formData: FormData) => {
  const response = await baseApi.post(
    "/profiles/members/update-profile-image/",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};

// Change Email APIs ------------------------------------------------------------------
export const requestEmailChangeApi = async (emailData: { new_email: string }) => {
  const response = await baseApi.post(
    "/profiles/members/request-email-change/",
    emailData
  );
  return response.data;
};

export const confirmEmailChangeApi = async (confirmationData: {
  old_email_code: string;
  new_email_code: string;
}) => {
  const response = await baseApi.post(
    "/profiles/members/confirm-email-change/",
    confirmationData
  );
  return response.data;
};

// Phone number APIs ------------------------------------------------------------------
export const requestPhoneVerificationApi = async (phoneData: {
  phone_number: string;
}) => {
  const response = await baseApi.post(
    "/profiles/members/request-phone-verification/",
    phoneData
  );
  return response.data;
};

export const verifyPhoneApi = async (verificationData: {
  phone_number: string;
  activation_code: string;
}) => {
  const response = await baseApi.post(
    "/profiles/members/verify-phone/",
    verificationData
  );
  return response.data;
};

export const removePhoneApi = async () => {
  const response = await baseApi.post("/profiles/members/remove-phone/");
  return response.data;
};

export const deleteAcademicRecordApi = async () => {
  const response = await baseApi.delete(
    "/profiles/members/delete-academic-record/"
  );
  return response.data;
};

// Toggle Visibility API --------------------------------------------------------------
export const toggleVisibilityApi = async ({
  memberId,
  is_hidden_by_confidants,
}: {
  memberId: number;
  is_hidden_by_confidants: boolean;
}) => {
  const response = await baseApi.post("/profiles/members/toggle-visibility/", {
    memberId,
    is_hidden_by_confidants,
  });
  return response.data;
};

// Member Gifts -----------------------------------------------------------------------
export const fetchSpiritualGiftsApi = async () => {
  const response = await baseApi.get("/profiles/spiritual-gift/spiritual-gifts/");
  return response.data;
};

export const submitSurveyAnswersApi = async () => {
  const response = await baseApi.post("/profiles/spiritual-gift/submit-survey/");
  return response.data;
};

export const fetchSurveyQuestionsApi = async (language: string = "en") => {
  const response = await baseApi.get(
    `/profiles/spiritual-gift-survey-questions/gift-questions?language=${language}`
  );
  return response.data;
};

export const submitOneAnswerApi = async (answer: {
  questionId: number;
  value: number;
  questionNumber: number;
}) => {
  const response = await baseApi.post(
    `/profiles/spiritual-gift-survey/${answer.questionId}/submit-answer/`,
    {
      question_id: answer.questionId,
      answer: answer.value,
      question_number: answer.questionNumber,
    }
  );
  return response.data;
};

export const fetchSurveyAnswersApi = async () => {
  const response = await baseApi.get("/profiles/spiritual-gift-survey/get-answers");
  return response.data;
};

export const fetchSurveyProgressApi = async () => {
  const response = await baseApi.get("/profiles/spiritual-gift-survey/get-progress");
  return response.data;
};

export const cancelSurveyApi = async () => {
  const response = await baseApi.delete(
    "/profiles/spiritual-gift-survey/cancel-survey/"
  );
  return response.data;
};